import { useEffect, useState } from 'react';
import { Button, Item, Label } from 'semantic-ui-react';
import * as moment from 'moment-timezone';
import './Post.scss';

export const Post = ({ post, removeItem, moveUp, moveDown, event }) => {
  const [current, setCurrent] = useState(post);

  useEffect(() => setCurrent(post), [post]);

  const getPost = () => (
    <Item className="post-item-container">
      {current.promoted && (
        <Item.Image
          label={{ color: 'blue', ribbon: true, content: 'Promoted' }}
          size="small"
          className="post-image-preview"
          src={current.image_url}
        />
      )}
      {!current.promoted && <Item.Image size="small" className="post-image-preview" src={current.image_url} />}

      <Item.Content>
        <Item.Header as="a" href={current.url} target="_blank">
          {current.headline}
        </Item.Header>
        <Item.Extra>
          {!current.is_event && (
            <Label image as="a" href={current.author_profile_url} target="_blank">
              <img src={current.author_avatar} alt="author" />
              {current.author}
            </Label>
          )}

          <Label>
            {current.is_event ? 'Event Date' : 'Date Published'}

            <Label.Detail>{moment(current.created_ts).tz('America/Chicago').format('LLLL')}</Label.Detail>
          </Label>

          {!current.is_event && (
            <Label>
              Views
              <Label.Detail>{current.total_views}</Label.Detail>
            </Label>
          )}

          <Button icon="trash" size="mini" floated="right" negative onClick={() => removeItem(post)} />
          <Button icon="arrow up" size="mini" floated="right" onClick={moveUp} />
          <Button icon="arrow down" size="mini" floated="right" onClick={moveDown} />
        </Item.Extra>
        {/* <Item.Extra>
          {current?.sections?.map((section, idx) => (
            <Label content={section.toUpperCase()} key={idx} />
          ))}
        </Item.Extra> */}
      </Item.Content>
    </Item>
  );

  return <>{post && getPost()}</>;
};

export default Post;
